declare global {
  interface Window {
    RUNTIME_ENV?: Record<string, unknown>;
  }
}

export function getRuntimeConfig(): Record<string, unknown> {
  if (typeof window !== "undefined") {
    if (window.RUNTIME_ENV) {
      return window.RUNTIME_ENV;
    }
    const body = document?.body;
    if (body && body.dataset && body.dataset.cortexRoot) {
      try {
        const raw = body.dataset.cortexRoot;
        try {
          return JSON.parse(raw);
        } catch (_ignored) {
          const textarea = document.createElement("textarea");
          textarea.innerHTML = raw;
          const decoded = textarea.value;
          return JSON.parse(decoded);
        }
      } catch (_e) {
        console.warn("Failed to parse injected config");
      }
    }
  }
  try {
    const dynamicRequire = eval("require");
    const cortexConfig = dynamicRequire("cortex-config");
    const resolvedConfig =
      cortexConfig && cortexConfig.default
        ? cortexConfig.default
        : cortexConfig;
    return resolvedConfig || {};
  } catch (e) {
    return {};
  }
}
